// Configuration for the React frontend
// App name will be loaded from REACT_APP_NAME env var first, then backend config as fallback
let appNameFromBackend: string | null = null;

export const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  get appName(): string {
    // Priority: REACT_APP_NAME (frontend .env) > backend API > hardcoded default
    return process.env.REACT_APP_NAME || appNameFromBackend || 'DocumentAI';
  },
  setAppName(name: string): void {
    appNameFromBackend = name;
  },
  version: process.env.REACT_APP_VERSION || '1.0.0',
  // File upload settings
  maxFileSizeBytes: 15 * 1024 * 1024, // 15MB
  maxFileSizeMB: 15,
};

// Load app name from backend on initialization (only if REACT_APP_NAME is not set)
if (typeof window !== 'undefined' && !process.env.REACT_APP_NAME) {
  // Use setTimeout to avoid circular dependency
  setTimeout(() => {
    import('./services/api').then(({ apiService }) => {
      apiService.getConfig()
        .then((backendConfig) => {
          config.setAppName(backendConfig.app_name);
        })
        .catch(() => {
          // Silently fail, use fallback
          console.warn('Failed to load app config from backend, using fallback');
        });
    });
  }, 0);
}

export default config;
